import React from "react";
import Typography from "@mui/material/Typography";
import Container from "src/components/common/Layout/Container";
import SpecificationAccordionItem from "src/components/Specification/SpecificationAccordion/SpecificationAccordionItem";
import { InstructionItemSchema } from "src/models/instruction/getInstruction";
import { useMediaQuery } from "@mui/material";
import { Theme } from "@mui/system";
import { colors } from "src/config/colors";
import {
  InstructionDisclaimer,
  RlsSourceNote,
} from "src/components/NewProductPage/components/RlsNotices";

interface SpecificationAccordionListProps {
  instructionData?: InstructionItemSchema[] | null;
  description?: string;
  title?: string;
  descMatch?: string | null;
}

const SpecificationAccordionList: React.FC<SpecificationAccordionListProps> = ({
  instructionData,
  description,
  title,
  descMatch,
}) => {
  const isLargeScreenDown = useMediaQuery((theme: Theme) =>
    theme.breakpoints.up("lg")
  );

  if (!instructionData) return null;

  return (
    <Container
      wrapperSx={{
        marginTop: { xs: 0, lg: 2 },
        marginBottom: { xs: 2, lg: 4 },
      }}
      isWithPaper
      paddingX="0"
      marginBottom={1.5}
      elevation={0}
      paddingBottom="5px"
    >
      <Container id="instruction" paddingBottom={3.25} paddingTop={3.25}>
        <Typography
          fontWeight="500"
          fontSize="29px"
          variant="h6"
          component="h2"
          paragraph={!!description}
        >
          {title}
        </Typography>
        {description && (
          <Typography variant="body1" component="p">
            {description}
          </Typography>
        )}
      </Container>
      {instructionData.length === 0 ? (
        <Typography
          sx={{
            padding: "16px",
            fontSize: "16px",
            color: colors.black2,
          }}
        >
          К сожалению, инструкция для данного товара еще не подготовлена.
        </Typography>
      ) : (
        <>
          {descMatch === "assumed" && <InstructionDisclaimer />}
          {instructionData.map((value, index) => (
            <SpecificationAccordionItem
              isLargeScreenDown={isLargeScreenDown}
              id={value.key}
              key={value.key + index}
              title={value.rusName}
              description={value.text}
            />
          ))}
          {descMatch === "exact" && <RlsSourceNote />}
        </>
      )}
    </Container>
  );
};

export default SpecificationAccordionList;
